import React, {useEffect, useState} from "react";
import {post} from "../utils/post";
import {Paper, Typography} from "@mui/material";
import BarChart from "./BarChart";
import LineChart from "./LineChart";


export const Statistics = () => {
    const [statistics, setStatistics] = useState(null);

    useEffect(() => {
        post({method: "statistics"}, true).then(setStatistics);
    }, [])

    if (!statistics) return;

    const getLineData = (statistics) => {
        const values = Object.entries(statistics.problems).map(([, {date, isRight}]) => ({date, isRight}));
        const firstDate = values.map(v => v.date).sort((a, b) => a - b)[0];
        const today = +new Date(new Date(statistics.info.date).toLocaleDateString("en-CA"));
        const lineData = [];
        for (let d = firstDate; d <= today; d += 1000 * 60 * 60 * 24) {
            const v = values.filter(v => v.date <= d).map(v => v.isRight);
            const solved = v.filter(v => v).length;
            const notSolved = v.filter(v => !v).length;
            const date = new Date(d).toLocaleDateString("ru");
            lineData.push([date, solved, notSolved])
        }
        return lineData;
    }
    const getBarData = (statistics) => {
        const values = Object.entries(statistics.problems).map(([, {date, isRight}]) => ({date, isRight}));
        const solved = values.filter(v => v.isRight).length;
        const notSolved = values.filter(v => !v.isRight).length;
        return [solved, notSolved]
    }

    return (
        <div className={"statistics"} style={{width: "80vw"}}>
            <Paper elevation={3} sx={{padding: "32px", height: "calc(100% - 64px)"}}>
                <Typography align={"center"} variant={"h5"} gutterBottom>Статистика по задачам</Typography>
                <div style={{padding: 8, height: "calc(100% - 40px)"}}>
                    <div style={{height: "50%"}}>
                        <BarChart title={"Всего"} values={getBarData(statistics)}/>
                    </div>
                    <hr/>
                    <div style={{height: "50%"}}>
                        <LineChart title={"По дням"} values={getLineData(statistics)}/>
                    </div>
                </div>
            </Paper>
        </div>
    )
}
